export const QA_NAME_USER_STAFF_INVITATION_MODAL = 'editStaffInvitation'
